import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment'; 
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-revaluation-result',
  templateUrl: './revaluation-result.component.html',
  styleUrls: ['./revaluation-result.component.scss']
})
export class RevaluationResultComponent implements OnInit {

  ResultForm: FormGroup;
  dialogRef: MatDialogRef<any>;
  submitButton = true;
  editButton = false;
  deleteButton = false;
  Row1 = true;
  Row2 = true;
  Row3 = true;
  APIService: any;
  codeMarks1List: any;
  filteredCodeMarks1: any;
  submitpayload: any;
  filteredCodeType: any;
  codeTypeList: any;
  filteredDataList: any;
  DataList: any;
  RGInCode = 0;
  G_Regn_Roll = '';
  TitleOne = 'titleOne';
  TitleTwo = 'TitleTwo';
  TitleThree = 'TitleThree';
  EcId: any;
  Shid: any;
  Rollno = false;
  Regno = false;
  gridList: any;
  SessionNo: any;
  constructor(public umsService: UmsService,private spinner:NgxSpinnerService,
    private modalPopupService: ModalpopService, private httpClient: HttpClient,
    private route: ActivatedRoute,
    public fb: FormBuilder) {  this.APIService = environment.serviceUrl;  }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    this.route.queryParams.subscribe((params) => {
      this.RGInCode = params['MenuCode'];
      this.resetValues();
      this.loadpage(this.RGInCode);
      this.ResultForm = this.fb.group({
        EcId: new FormControl('',[Validators.required]),
        listNo2: new FormControl(''),
        listNo3: new FormControl(''),
        Valid: new FormControl(''),
        Chng: new FormControl(''),
        Batch: new FormControl('',[Validators.required, Validators.pattern("^[a-zA-Z0-9]*$")]),
        EmCode: new FormControl('',[Validators.pattern("^[a-zA-Z0-9]*$")]),
        ExcpCode: new FormControl(''),
        SetRem: new FormControl('',[Validators.pattern("^[A-Z]*$")]),
        Sub: new FormControl('',[Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
        Head: new FormControl('',[Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
        RegnNo: new FormControl('',[Validators.pattern("^[a-zA-Z0-9]*$")]),
        RollNo: new FormControl('',[Validators.pattern("^[a-zA-Z0-9]*$")]),
        Marks: new FormControl(''),
        MarksD: new FormControl(''),
        Grade: new FormControl('',[Validators.pattern("^[A-Z]*$")]),
        Status: new FormControl('',[Validators.pattern("^[A-Z]*$")]),
        Comment: new FormControl('',[Validators.pattern("^[a-zA-Z0-9]*$")]),
        Mesg: new FormControl('',[Validators.pattern("^[a-zA-Z0-9]*$")]),
       } );
       this.fetchCodeMarks1();
       this.conditions();
       this.checkDecimal();
    });
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }

  resetValues(){
    this.submitButton = true;
    this.editButton = false;
    this.deleteButton = false;
    this.Rollno = false;
    this.Regno = false;
    this.Row1 = false;
      this.Row2 = false;
      this.Row3 = false;
  }

  loadpage(e) {
    if (e == 24) {
      this.TitleOne = 'Revaluation';
      this.fetchList();
    } else if (e == 21) {
      this.TitleOne = 'Change Updated Result';
      this.fetchList();
    } 
  }

  conditions(){
    this.G_Regn_Roll = this.umsService.secretdata['RegnRoll'];
    if(this.G_Regn_Roll == 'G'){
      this.Rollno = false;
      this.Regno = true;
    }
    else{
      this.Rollno = true;
      this.Regno = false;
    }

   
  }

  fetchList() {
    let payload = {};
    payload['SnNo'] = this.SessionNo;
    payload['InCode'] = this.RGInCode;
    payload['OpId'] = sessionStorage.getItem('userId');
    this.umsService.getExmFrmDrpList(payload).subscribe((res) => {
      if (res.status) {
        this.DataList = res.data;
        this.filteredDataList = this.DataList.slice();
      }
    });
  }

  list(){
      this.Row1 = true;
      this.Row2 = true;
      this.Row3 = true;
      // this.ControlLock(this.EcId)
  }

  icrbtn(){
      this.Row1 = true;
      this.Row2 = true;
      this.Row3 = true;
  }


  getListData(id){
    this.ResultForm.controls['ListNo2'].setValue(id.Oper);
    this.ResultForm.controls['listNo3'].setValue(id.EcDesc);
    this.EcId = id.EcId;
    this.Shid = id.InShId;
    this.GridData(id.EcId);
    // this.checkDecimal(id);
  }

  fetchCodeMarks1() {
    const payload = {};
    payload['CdType'] = 'EX';
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.codeTypeList = res.data;
        this.filteredCodeType = this.codeTypeList.slice();
      } else {
       
      }
    });
  }

  checkDecimal(){
    let payload = {};
    payload['EmId'] = 523;
    this.umsService.checkForDecimal(payload).subscribe((res) => {
      if(res.data['EmMarksD'] == "Y"){
        this.setValidor();
      }else{
        this.removeValidator();
      }
    });
  }

  setValidor() {
    this.ResultForm.controls['Marks'].setValidators([Validators.pattern('^((100)|([0-9]{1,2}(.[0-9]{1,2})?))$')]);
    
  }

  removeValidator() {
    this.ResultForm.controls['Marks'].clearValidators();
  }
  
  // ControlLock(id){
  //   const payload = {};
  //   payload['EcId'] = id;
  //   payload['LoginId'] = sessionStorage.getItem('userId');
  //   this.umsService.EditCtrlLock(payload).subscribe((res) => {
  //     if (res.status) {
  //       // this.subList = res.data;
  //       // this.filteredSubList = this.subList.slice();
  //     } else {
  //      this.Row1 = false;
  //      this.Row2 = false;
  //      this.Row3 = false;
  //     }
  //   });
  // }



 // ControlUnLock(id){
  //   const payload = {};
  //   payload['CMarks'] = id;
  //   payload['LoginId'] = 0;
  //   this.umsService.EditCtrlLock(payload).subscribe((res) => {
  //     if (res.status) {
  //       // this.subList = res.data;
  //       // this.filteredSubList = this.subList.slice();
  //     } else {
  //     }
  //   });
  // }

  
  GridData(EcId) {
    const payload = {};
    payload['EcId'] = EcId;
    payload['Chng'] = this.ResultForm.value['Chng'];
    payload['Valid'] = this.ResultForm.value['Valid'];
    this.umsService.SearchResult(payload).subscribe((res) => {
      if (res.status) {
        this.gridList = res.data;
        
      } else {
       
      }
    });
  }


  deletee(e, k){
    if (e === 'true'){
      this.prepopulationForDelete(k);
    } else {
      
    }
  }

  prepopulationForDelete(data){
    this.editButton = false;
    this.submitButton = false;
    this.deleteButton = true;
    this.ResultForm = this.fb.group({
      EcId: new FormControl(data.EcId,[Validators.required]),
      listNo2: new FormControl(data.listNo2),
      listNo3: new FormControl(data.listNo3),
      Valid: new FormControl(data.Valid),
      Chng: new FormControl(data.Chng),
      Batch: new FormControl(data.Batch,[Validators.required, Validators.pattern("^[a-zA-Z0-9]*$")]),
      EmCode: new FormControl(data.EmCode,[Validators.pattern("^[a-zA-Z0-9]*$")]),
      ExcpCode: new FormControl(data.ExcpCode),
      SetRem: new FormControl(data.SetRem,[Validators.pattern("^[A-Z]*$")]),
      Sub: new FormControl(data.Sub,[Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
      Head: new FormControl(data.Head,[Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
      RegnNo: new FormControl(data.RegnNo,[Validators.pattern("^[a-zA-Z0-9]*$")]),
      RollNo: new FormControl(data.RollNo,[Validators.pattern("^[a-zA-Z0-9]*$")]),
      Marks: new FormControl(data.Marks),
      MarksD: new FormControl(data.MarksD),
      Grade: new FormControl(data.Grade,[Validators.pattern("^[A-Z]*$")]),
      Status: new FormControl(data.Status,[Validators.pattern("^[A-Z]*$")]),
      Comment: new FormControl(data.Comment,[Validators.pattern("^[a-zA-Z0-9]*$")]),
      Mesg: new FormControl(data.Mesg,[Validators.pattern("^[a-zA-Z0-9]*$")]),
     } );
  }
 
 

  edit(k,id){
    if (k === 'true') {
      this.prepopulation(id);
    }
  }


  prepopulation(data){
    this.editButton = true;
    this.submitButton = false;
    this.deleteButton = false;
    this.ResultForm = this.fb.group({
      EcId: new FormControl(data.EcId,[Validators.required]),
      listNo2: new FormControl(data.listNo2),
      listNo3: new FormControl(data.listNo3),
      Valid: new FormControl(data.Valid),
      Chng: new FormControl(data.Chng),
      Batch: new FormControl(data.Batch,[Validators.required, Validators.pattern("^[a-zA-Z0-9]*$")]),
      EmCode: new FormControl(data.EmCode,[Validators.pattern("^[a-zA-Z0-9]*$")]),
      ExcpCode: new FormControl(data.ExcpCode),
      SetRem: new FormControl(data.SetRem,[Validators.pattern("^[A-Z]*$")]),
      Sub: new FormControl(data.Sub,[Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
      Head: new FormControl(data.Head,[Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
      RegnNo: new FormControl(data.RegnNo,[Validators.pattern("^[a-zA-Z0-9]*$")]),
      RollNo: new FormControl(data.RollNo,[Validators.pattern("^[a-zA-Z0-9]*$")]),
      Marks: new FormControl(data.Marks),
      MarksD: new FormControl(data.MarksD),
      Grade: new FormControl(data.Grade,[Validators.pattern("^[A-Z]*$")]),
      Status: new FormControl(data.Status,[Validators.pattern("^[A-Z]*$")]),
      Comment: new FormControl(data.Comment,[Validators.pattern("^[a-zA-Z0-9]*$")]),
      Mesg: new FormControl(data.Mesg,[Validators.pattern("^[a-zA-Z0-9]*$")]),
     } );
    
  }

  addnewrecord(e){
    if (e === 'true'){
      this.editButton = false;
      this.submitButton = true;
      this.deleteButton = false;
       this.ResultForm.reset();
    } 
    else {
      this.editButton = true;
      this.submitButton = false;
      this.deleteButton = true;
        this.ngOnInit();
    }
  }


  submit(){
    if (this.ResultForm.invalid) {
      this.ResultForm.get('EcId').markAsTouched();
      this.ResultForm.get('Sub').markAsTouched();
      this.ResultForm.get('Batch').markAsTouched();
      this.ResultForm.get('Head').markAsTouched();
      if(this.Regno == true){
        this.ResultForm.controls['RegnNo'].setValidators(Validators.required);
        this.ResultForm.get('RegnNo').markAsTouched();
      }
      else if(this.Regno == false){
        this.ResultForm.controls['RegnNo'].clearValidators();
        this.ResultForm.get('RegnNo').markAsUntouched();
      }
      if(this.Rollno == true){
        this.ResultForm.controls['RollNo'].setValidators(Validators.required);
        this.ResultForm.get('RollNo').markAsTouched();
      }
      else if(this.Rollno == false){
        this.ResultForm.controls['RollNo'].clearValidators();
        this.ResultForm.get('RollNo').markAsUntouched();
      }
      return;
    } else {
      this.submitRevalResult();
    }
  }
  submitRevalResult() {
    this.spinner.show();
    this.submitpayload = this.ResultForm.value;
    if(this.submitpayload.ExcpCode != "" || this.submitpayload.ExcpCode != null){
      if(this.submitpayload.SetRem != 'R'){
        this.submitpayload.SetRem = 'S'
      }
    }
    else if(this.submitpayload.ExcpCode == "" || this.submitpayload.ExcpCode == null){
      this.submitpayload.SetRem = ""
    }
    if(this.submitpayload.Sub == "" || this.submitpayload.Sub == null){
      let  data = {}
        data['message'] = "Subject Required"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    }
    if(this.submitpayload.Status != "" || this.submitpayload.Status != null){
      this.submitpayload.Marks = "";
      this.submitpayload.MarksD = "";
      this.submitpayload.Grade = "";
    }
    else if(this.submitpayload.Status != "A" || this.submitpayload.Status != "U"){
      let  data = {}
        data['message'] = "Status Can Be A-Absent/U-Unfair Means"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    }
    if(this.submitpayload.Grade != "" || this.submitpayload.Grade != null){
      this.submitpayload.Marks = "";
      this.submitpayload.MarksD = "";
    }
    else if(this.submitpayload.Grade == "" || this.submitpayload.Grade == null){
      this.submitpayload.Marks = 0;
      this.submitpayload.Marks.setValue(0);
    }
    if(this.submitpayload.Marks == 0){
      let  data = {}
      data['message'] = "Confirm Zero Marks"
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    }

    this.umsService.addResult(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status){
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      } else {
        this.spinner.hide();
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
    
  }


  delete(){
    const  data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes'){
        this.Deletedata(this.ResultForm.value);
      }else{
        this.dialogRef.close();
      }
    });
  }

  Deletedata(id){
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),  body: {
        
        ExcpCode: id.ExcpCode,
        Head: id.Head,
        EcId: id.EcId,
        Batch: id.Batch,
        EmCode: id.EmCode,
        RollNo: id.RollNo,
        RgNo: id.RgNo,
        Sub: id.Sub,
        Marks: id.Marks,
        MarksD: id.MarksD,
        Grade: id.Grade,
        Status: id.Status,
        SetRem: id.SetRem,
        Comment: id.Comment,
        Mesg: id.Mesg,
      },
    };
      this.httpClient.delete(this.APIService + '/inputs/EditChResult', options)
      .subscribe((s) => {
        this.spinner.hide();
        let cc = [];
        cc.push(s);
        let  data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.ngOnInit();
        });
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let  data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.ngOnInit();
        // this.umsService.openSnackbar(ERROR.error.message);
  
     });
  }

  update(){
    if (this.ResultForm.invalid) {
      this.ResultForm.get('EcId').markAsTouched();
      this.ResultForm.get('Sub').markAsTouched();
      this.ResultForm.get('Batch').markAsTouched();
      this.ResultForm.get('Head').markAsTouched();
      return;
    } else {
      this.updateResult();
    }
  }
  


  updateResult(){
    this.spinner.show();
    this.submitpayload = this.ResultForm.value;
    this.umsService.updateResult(this.submitpayload).subscribe(res => {
      if (res.status){
        this.spinner.hide();
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      } else {
        this.spinner.hide();
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });

  }

}
